import React, { useState } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Search } from 'semantic-ui-react';
import useDebounce from '@/utils/debounce';
import filteredSuggestions, { sanitiseFilterSuggestion } from '@/utils/suggestionsHelper';
import FilterSuggestion from './FilterSuggestion';

const Filter = ({
  className,
  disabled,
  error,
  filterTerm,
  fluid,
  label,
  loading,
  message = 'table.filter.placeholder',
  onFilter,
  suggestions,
  updateFilter,
}) => {
  const intl = useIntl();
  const debounceFilter = useDebounce(() => onFilter && onFilter());
  const [focused, setFocused] = useState(false);
  const inputRef = React.useRef(null);
  const prefix = intl.formatMessage({ id: 'table.filter.show.results.label' });

  const onKeyDown = (e) => {
    if (onFilter && e.key === 'Enter') {
      const term = (filterTerm || '').trim();
      const colon = term.indexOf(':');
      if (colon > 0 && !term.slice(colon + 1).trim()) { return; }
      debounceFilter.cancel();
      onFilter();
    }
  };

  const onChange = (e, { value }) => {
    const { filter, isOnlyPrefix } = sanitiseFilterSuggestion(value, suggestions);
    if (updateFilter) { updateFilter({ value: filter }); }
    if (isOnlyPrefix) {
      debounceFilter.cancel();
    } else {
      debounceFilter();
    }
  };

  const onResultSelect = (e, { result }) => {
    if (updateFilter) { updateFilter({ value: result.value }); }
    debounceFilter.cancel();
    if (onFilter && result.displayValue) { onFilter(); }
    inputRef.current.focus();
  };

  return (
    <Search
      className={clsx('aridhia-filter primary', className)}
      {...(error || disabled) && { disabled: true }}
      fluid={fluid}
      input={{
        ref: inputRef,
        icon: 'filter',
        iconPosition: 'left',
        ...(label && { label, labelPosition: 'right' }),
      }}
      loading={loading}
      minCharacters={0}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onKeyDown={onKeyDown}
      onResultSelect={onResultSelect}
      onSearchChange={onChange}
      placeholder={intl.formatMessage({ id: message })}
      resultRenderer={FilterSuggestion}
      results={focused ? filteredSuggestions(filterTerm, suggestions, prefix) : undefined}
      showNoResults={false}
      size="small"
      value={filterTerm}
    />
  );
};

export default Filter;
